/**
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";

// Material Kit 2 React routes
import routes from "routes";
import AnalysisView from "./layouts/analysis/analysisview";
import DataView from "./layouts/data/dataview";
import Assessment from "./layouts/assessment";
import ComputingNewJob from "./layouts/computing/computingNewJob";
import ComputingJobView from "./layouts/computing/computingJobView";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {/* 全局路由 */}
        {getRoutes(routes)}
        {/* 根地址路由 */}
        <Route path="*" element={<Navigate to="/home" />} />
        {/* 地址中添加参数的路由 */}
        <Route path="/analysis/:proID" element={<AnalysisView />} />
        <Route path="/assessment/:country" element={<Assessment />} />
        <Route path="/data-map/:proID" element={<DataView />} />
        <Route path="/computing/new/:modelID" element={<ComputingNewJob />} />
        <Route path="/computing/view/:jobID" element={<ComputingJobView />} />
      </Routes>
    </ThemeProvider>
  );
}
